module.exports = __webpack_public_path__ + "img/shiba.8f9746b8.png";